import React from "react";
import pic from "../../../icons/mana.jpg";


class PeopleLeft extends React.Component {

    render() {
        return (
            <div className='word-wrap'>
                <h2>Site management</h2>
                <div className='left-pane-pic'>
                    <img className="left-pane-pic" style={{marginTop:'50px', width:'180px', height:'180px'}} src={pic} alt="Logo" />
                </div>
                <div style={{marginTop:'30px'}}>Provide us information about management</div>
            </div>
        );
    }
}
export default PeopleLeft







// WEBPACK FOOTER //
// ./src/components/CreateSite/Step4/PeopleLeft.js